// import { v4 as uuid } from 'uuid';
import { userAssumeRole } from "@/api/userApi";
;

// eslint-disable-next-line @typescript-eslint/no-var-requires
const OSS = require('ali-oss');

const REG = /.*(\.[^.]+)$/;
 
function uuid() { 
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";
 
    var uuid = s.join("");
    return uuid;
}
function getSize(file,index){
  return new Promise(res=>{
    let reader =new FileReader();
    reader.onload=function(e){
     let txt =e.target.result
     let img
      if(index==0){
       img=document.createElement("img")
       img.src=txt
       img.onload= function(){
      res({
       w:img.width,
       h:img.height
      })
    }
 
        
      }else if(index ==1){
         img=document.createElement("video")
         img.src=txt
         img.addEventListener("canplay",function(e){
          res({
            w:e.target.videoWidth ,
            h:e.target.videoHeight
           })
         })
    
         

      }
   

   }
  
   reader.readAsDataURL(file)


  })
}
/**
 * 上传图片
 * 参考链接：https://help.aliyun.com/document_detail/383950.html
 */
// @TODO 大文件分片上传判断处理
export async function upload(file,i) {
   
  let Size =await getSize(file.raw,i)
  //  console.log(Size,file.name.replace(REG, '$1'),99)

  let sts = await userAssumeRole(); //获取授权信息
  sts=sts.data.data.result
  const client = new OSS({
    region: 'oss-us-west-1', // yourRegion填写Bucket所在地域。以华东1（杭州）为例，yourRegion填写为oss-cn-hangzhou。
    accessKeyId:sts.Credentials.AccessKeyId, // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
    accessKeySecret:sts.Credentials.AccessKeySecret,
    stsToken: sts.Credentials.SecurityToken, // 从STS服务获取的安全令牌（SecurityToken）。
    bucket: "yhe-pro", // 填写Bucket名称。
  });
//   const { protocol, targetHost, pathPrefix } = sts;
  const suffixName = `/chat/${uuid()}-${Size.w}_${Size.h}${file.name.replace(REG, '$1')}`;
  const res = await new Promise(resolve => {
    client
    //   .multipartUpload
      .put(suffixName, file.raw, {
         // 指定该Object被下载时网页的缓存行为。
            "Cache-Control": "no-cache",
            // 'Access-Control-Request-Headers':'Content-Type',
            // 'Content-Type':''

      })
      .then(response => {
        resolve(response);
      });
  });
  const url =  res.name;
  return url;
}

